<template>
  <div class="hero-text-slider">
    <h1 v-if="typeof heroH1 !== 'undefined' && heroH1 !== ''" v-html="heroH1.replace(/\n/gi, '<br />')"/>
    <h2 v-if="typeof heroH2 !== 'undefined'" v-html="heroH2.replace(/\n/gi, '<br />')"/>
    <p v-if="typeof heroP !== 'undefined'" v-html="heroP.replace(/\n/gi, '<br />')"/>
    <router-link
      v-if="heroLink !== ''"
      :to="heroLink"
      class="postumia__link">
        {{ heroLinkText }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'HeroTextSlider',
  props: {
    heroH1: {
      type: String,
      required: false
    },
    heroH2: {
      type: String,
      required: false
    },
    heroP: {
      type: String,
      required: false
    },
    internalPage: {
      type: Boolean,
      default: false
    },
    heroLink: {
      type: String,
      required: true
    },
    heroLinkText: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
  @import "./text.scss";
</style>
  